import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAveragePeakAngleVelocity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_116",
	"data-name": "Group 116",
	xmlns: "http://www.w3.org/2000/svg",
	width: 43.896,
	height: 25.584,
	viewBox: "0 0 43.896 25.584",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_114",
			"data-name": "Group 114",
			transform: "translate(0 0)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_260",
				"data-name": "Path 260",
				d: "M247.707,385.568c-.208-.261-.45-.556-.709-.872a19.569,19.569,0,0,1-2.652-3.722c-.442-1.31-1.211-5.076-1.521-6.635a1.07,1.07,0,0,0-.3-.552c.134-.163.281-.332.455-.507,1.123-1.131,3.93-3.9,3.931-3.9l-1.262-1.281s-2.817,2.775-3.945,3.911a8.055,8.055,0,0,0-1.571,2.168l-.071.049a2.859,2.859,0,0,1-1.377-1.058,3.612,3.612,0,0,1-.417-1.446c0-.04-.018-.076-.024-.115.268-.188.6-.436,1.034-.761a26,26,0,0,0,3.795-4.295.9.9,0,1,0-1.461-1.05,23.9,23.9,0,0,1-3.413,3.9c-.565.423-.9.66-1.088.791a1.816,1.816,0,0,0-1.154-.059,8.86,8.86,0,0,0-1.57.626,16.316,16.316,0,0,0-2.642,1.644,5.38,5.38,0,0,0-1.9.685.9.9,0,0,0-.505.674,5.6,5.6,0,0,0,1.56,4.242c1.622,1.933,7.467,7.615,7.744,7.883.131.116,3.24,2.857,5.992,3.13q.279.028.544.027a2.955,2.955,0,0,0,2.739-1.32A1.941,1.941,0,0,0,247.707,385.568Zm-1.367,1.3c-.106.2-.6.455-1.526.363-1.8-.178-4.2-2-4.946-2.657-.06-.058-6.026-5.858-7.59-7.722a4.648,4.648,0,0,1-1.145-2.368c.283-.123.536-.224.669-.267l.134.013a.9.9,0,0,0,.685-.22,13.266,13.266,0,0,1,2.571-1.639,6.314,6.314,0,0,1,1.271-.5c.011.008.012.013.012.016h0a5.337,5.337,0,0,0,.649,2.176,4.918,4.918,0,0,0,2.884,2.036.9.9,0,0,0,.777-.17c.145-.115.306-.232.461-.336.409,2.01,1,4.779,1.4,5.947a17.872,17.872,0,0,0,2.966,4.287c.253.308.49.6.692.852C246.382,386.793,246.355,386.842,246.339,386.872Z",
				transform: "translate(-225.614 -365.13)",
				fill: "current"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_261",
				"data-name": "Path 261",
				d: "M233.848,400.7l-1.678-2.943a.9.9,0,0,0-1.563.891l.69,1.21a10.967,10.967,0,0,1-5.887-3.244c-3.461-3.461-2.381-6.467-2.326-6.612a.9.9,0,0,0-1.67-.668c-.069.169-1.628,4.2,2.724,8.552a12.89,12.89,0,0,0,6.416,3.656l-.876.5a.9.9,0,0,0,.891,1.563l2.942-1.678a.9.9,0,0,0,.409-1.061A.877.877,0,0,0,233.848,400.7Z",
				transform: "translate(-221.088 -378.139)",
				fill: "current"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_115",
			"data-name": "Group 115",
			transform: "translate(26.463 4.235)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_262",
				"data-name": "Path 262",
				d: "M292.9,377.94v-1.5a1.9,1.9,0,0,0-1.9-1.9h-2.457a1.9,1.9,0,0,0-1.9,1.9v1.492a7.589,7.589,0,0,0-1.161.649.9.9,0,1,0,1.017,1.484,5.793,5.793,0,1,1-2.442,5.693l.921.921a.9.9,0,0,0,1.272-1.272l-2.4-2.4a.9.9,0,0,0-1.272,0l-2.4,2.4a.9.9,0,0,0,1.272,1.272l.8-.8A7.584,7.584,0,1,0,292.9,377.94Zm-4.449-.561v-.936a.1.1,0,0,1,.1-.1H291a.1.1,0,0,1,.1.1v.94a7.566,7.566,0,0,0-1.325-.124A7.647,7.647,0,0,0,288.447,377.379Z",
				transform: "translate(-279.928 -374.547)",
				fill: "current"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_263",
				"data-name": "Path 263",
				d: "M300.716,386.529a.9.9,0,0,0-.9.9v4.012a.9.9,0,0,0,.264.636l2.159,2.159a.9.9,0,0,0,1.272-1.272l-1.9-1.9v-3.639A.9.9,0,0,0,300.716,386.529Z",
				transform: "translate(-290.872 -381.14)",
				fill: "current"
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgAveragePeakAngleVelocity);
export { ForwardRef as ReactComponent };
